]<!-- =========================================================================================
    File Name: Faq.vue
    Description: FAQ Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="vx-row">
    <vx-card>
      <vs-button color="primary" type="border" icon="add" to="product/create"
        >Create Product</vs-button
      >
      <br />
      <!-- FAQ COL -->
      <div class="vx-col w-full">
        <div class="vx-row margin-custom">
          <div
            class="vx-col w-full sm:w-1/2 lg:w-1/4 mb-base md:mt-0"
            v-for="product in products"
            :key="product.id"
          >
            <product-card :product="product" @update="deleteProductById" />
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import axios from '../../../axios'
import ProductCard from '../template/ProductCard.vue'


import moment from 'moment'
export default {
  data() {
    return {
      queryProduct: '',
      userAuth: this.$store.state.user,
      checkBox1: [],
      payment_type: [],
      list_category_id: [],
      list_payment_type: [],
      budget_minimum: null,
      budget_maximum: null,
      search: '',
      products: []


    }
  },
  watch: {

    search(newValue, oldValue) {
      this.getProduct(1000)
    }

  },
  mounted() {
    this.getProduct(0)

  },
  computed: {

  },
  methods: {
    goToAllCategory() {
      this.$router.push('/category/all')
      console.log('lala')
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    getProduct(delay) {
      //this.queryProduct = '?' + 'search=' + this.search
      axios.get(`/ecommerce/web/product/byStore/` + this.userAuth.company.id + "?type=dashboard", {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
          } else {
            console.log(res)
            this.products = []
            this.products = res.data

          }
        })
        .catch(error => {
          console.log(error.response)

        })

    },
    deleteProductById(id) {
      this.getProduct()

    }

  },

  components: {
    ProductCard,

  }

}
</script>

<style lang="scss">
#faq-page {
  .faq-bg {
    background-color: #fff;
  }
  // .sub-category {
  //   margin-left: 20px;
  // }

  // .margin-custom {
  //   margin: 40px;
  // }
}
</style>
